import { createSlice } from '@reduxjs/toolkit';
import {
    entornoNodo,
} from '../actions/entornoNodo';


export const EntornoReducerNodo = createSlice({
    name: 'entornoNodo',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(entornoNodo.pending, (state) => { state.loading = true })
            .addCase(entornoNodo.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(entornoNodo.rejected, (state) => { state.loading = false })
    }
})

export default EntornoReducerNodo.reducer;